import script from "./CRM10_022RPT.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM10_022RPT.vue?vue&type=script&setup=true&lang=js"

import "./CRM10_022RPT.vue?vue&type=style&index=0&id=1cf2591d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cf2591d"]])

export default __exports__